(function() {

  'use strict';

  function VeiculoCtrl($scope, $state, $stateParams, $filter, Pedido, Cep, Perfil, localStorageService) {

    var vm = this;

    vm.endereco = {};

    function setAreaAtendimento(area) {
      if (angular.isString(area)) {
        vm.area = 'foraDaArea';
      } else {
        vm.temCarro = Cep.temCarro();
        vm.temDiaAdicional = Cep.diaAdicional() > 0;
        vm.mensagemDiaAdicional = Cep.obsColeta();
        var carro = $filter('filter')(area.veiculos, "Carro", true)[0];
        if (!carro) {
          vm.veiculo = "Moto";
        } else {
          vm.veiculo = Pedido.getPedido().veiculo;
        }
      }
    };

    function verificaAreaDeAtendimento() {
      if ($stateParams.areaAtuacao) {
        setAreaAtendimento($stateParams.areaAtuacao);
      } else {
        Cep.buscarTipoVeiculoPorCepDadosColeta(vm.endereco.cep)
          .then(function(insideArea) {
            setAreaAtendimento(insideArea);
          }).catch(function(err) {
            if (err.status == 404) {
              vm.area = 'foraDaArea';
            } else {
              $scope.tratarErrosBackEnd(err);
            }
          });
      }
    };

    Pedido.getPedidoAsync()
      .then(function(pedido) {
        vm.observacao = pedido.observacao;
      });

    if ($stateParams.enderecoAtivo) {
      vm.endereco = angular.copy($stateParams.enderecoAtivo);
      verificaAreaDeAtendimento();
    } else {
      Perfil.getActiveAddress(true)
        .then(function(enderecoAtivo) {
          vm.endereco = angular.copy(enderecoAtivo);
          verificaAreaDeAtendimento();
        })
    }
    // metodo utilizado tb na controller de lista de encomendas para usuario freedom
    // o parametro forceValidation é um booleano que força a validação no nivel do form
    // o segundo para será um obj com os dados necessários para atualizar o pedido com veiculo e endereco utilizado
    vm.submeterVeiculoObservacao = function(formVeiculoObs, forceValidation, forceObj) {
      if (forceValidation || (formVeiculoObs && formVeiculoObs.$valid)) {

        var pedidoAtualizado = forceObj ? forceObj : {
          veiculo: vm.veiculo,
          observacao: vm.observacao,
          endereco: vm.endereco,
          enderecoEtiqueta: vm.endereco.etiqueta
        };

        Pedido.atualizar(Pedido.getPedido().id, pedidoAtualizado)
          .then(function(data) {
            Pedido.setPedido(data);
            if (forceValidation)
              $state.go('pedido.pagamento');
          })
          .catch($scope.tratarErrosBackEnd);
      }
    };

    vm.voltarOrigem = function() {
      if ($stateParams.origem) {
        $state.go($stateParams.origem);
      } else {
        $state.go('pedido.encomendas');
      }
    };


  };

  angular
    .module('mandaeApp')
    .controller('VeiculoCtrl', VeiculoCtrl)

})();
